import { Map, List, fromJS } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';

import * as admLib from 'libs/adminLib';
import * as normal from 'libs/normalizer';

// action types
const INITIAL_STORE = 'log/INITIAL_STORE';
const CHANGE_PARAM = 'log/CHANGE_PARAM';
const GET_SYSTEM_LOG = 'log/GET_SYSTEM_LOG';
const GET_SYSTEM_LOGDETAIL = 'log/GET_SYSTEM_LOGDETAIL';

// action creator
export const initialStore = createAction(INITIAL_STORE);
export const changeParam = createAction(CHANGE_PARAM);
export const getSystemLog = createAction(GET_SYSTEM_LOG, admLib.getSystemLog);
// export const getSystemLogdetail = createAction(GET_SYSTEM_LOGDETAIL, admLib.getSystemLogdetail);

// initial state
const initialState = fromJS({
  data: {
    result: -1,
    success: [],
    fail: []
  },
  indexByNo: {},
  needReload: false,
  param: Map({
    filter: Map({}),
    sort: [{ field: 'logNo', order: 'DESC' }]
  }),
  totalPages: 0,
  totalCount: 0
});

// reducer
export default handleActions(
  {
    // store 초기화
    [INITIAL_STORE]: (state, action) => {
      return initialState;
    },
    [CHANGE_PARAM]: (state, action) => {
      const { name, value } = action.payload;

      return state.setIn(['param', name], value);
    },
    ...pender({
      type: GET_SYSTEM_LOG,
      onSuccess: (state, action) => {
        const { data } = action.payload;
        const { offset, limit } = action.payload.config.params;

        // 전체 목록 수
        const totalCount = data.list.length > 0 ? data.list[0].rnum + offset : 0;
        // 전체 페이지 수
        const totalPages = Math.ceil(totalCount / limit);

        const stateObj = normal.payloadDataSaver(state, 'data', data);
        return stateObj
          .set('needReload', false)
          .set('totalPages', totalPages)
          .set('totalCount', totalCount)
          .set('indexByNo', fromJS(normal.listIndexByNo(data.list, 'logNo')));
      },
      onFailure: (state, action) => {
        console.log('GET_SYSTEM_LOG 실패');

        // 401 등 실패에 대한 적절한 처리 필요함
        //return state; //state.set('data', initialState.get('data'));
      }
    })
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/script/modules/log.js